module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/email.6191c011.svg";